// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectDashboardTabQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProjectDashboardTabQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', id: string, email: string, projectDashboardConfig?: { __typename?: 'DashboardConfig', tileConfigs?: Array<{ __typename?: 'DashboardTileConfig', tile: Types.DashboardTile, size: Types.DashboardTileSize }> | null | undefined } | null | undefined } | null | undefined };

export type SaveProjectDashboardMutationVariables = Types.Exact<{
  input: Types.SaveInternalUserInput;
}>;


export type SaveProjectDashboardMutation = { __typename?: 'Mutation', saveInternalUser: { __typename?: 'SaveInternalUserResult', internalUser: { __typename?: 'InternalUser', id: string, email: string, projectDashboardConfig?: { __typename?: 'DashboardConfig', tileConfigs?: Array<{ __typename?: 'DashboardTileConfig', tile: Types.DashboardTile, size: Types.DashboardTileSize }> | null | undefined } | null | undefined } } };


export const ProjectDashboardTabDocument = gql`
    query ProjectDashboardTab {
  currentInternalUser {
    id
    email
    projectDashboardConfig {
      tileConfigs {
        tile
        size
      }
    }
  }
}
    `;

/**
 * __useProjectDashboardTabQuery__
 *
 * To run a query within a React component, call `useProjectDashboardTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDashboardTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDashboardTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectDashboardTabQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>(ProjectDashboardTabDocument, options);
      }
export function useProjectDashboardTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>(ProjectDashboardTabDocument, options);
        }
export function useProjectDashboardTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>(ProjectDashboardTabDocument, options);
        }
export type ProjectDashboardTabQueryHookResult = ReturnType<typeof useProjectDashboardTabQuery>;
export type ProjectDashboardTabLazyQueryHookResult = ReturnType<typeof useProjectDashboardTabLazyQuery>;
export type ProjectDashboardTabSuspenseQueryHookResult = ReturnType<typeof useProjectDashboardTabSuspenseQuery>;
export type ProjectDashboardTabQueryResult = Apollo.QueryResult<ProjectDashboardTabQuery, ProjectDashboardTabQueryVariables>;
export const SaveProjectDashboardDocument = gql`
    mutation SaveProjectDashboard($input: SaveInternalUserInput!) {
  saveInternalUser(input: $input) {
    internalUser {
      id
      email
      projectDashboardConfig {
        tileConfigs {
          tile
          size
        }
      }
    }
  }
}
    `;
export type SaveProjectDashboardMutationFn = Apollo.MutationFunction<SaveProjectDashboardMutation, SaveProjectDashboardMutationVariables>;

/**
 * __useSaveProjectDashboardMutation__
 *
 * To run a mutation, you first call `useSaveProjectDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectDashboardMutation, { data, loading, error }] = useSaveProjectDashboardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectDashboardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectDashboardMutation, SaveProjectDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectDashboardMutation, SaveProjectDashboardMutationVariables>(SaveProjectDashboardDocument, options);
      }
export type SaveProjectDashboardMutationHookResult = ReturnType<typeof useSaveProjectDashboardMutation>;
export type SaveProjectDashboardMutationResult = Apollo.MutationResult<SaveProjectDashboardMutation>;
export type SaveProjectDashboardMutationOptions = Apollo.BaseMutationOptions<SaveProjectDashboardMutation, SaveProjectDashboardMutationVariables>;